module.exports = __webpack_public_path__ + "img/coupon-popup-bg-hen.486d4d62.png";